"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

var instanceOf = function instanceOf(o) {
  if (o && o.name) {
    return o.name;
  }

  return utils_1.ANONYMOUS;
};

exports.basicTypes = ['string', 'number', 'boolean', 'null', 'undefined', 'object', 'array'];
exports.default = {
  instanceOf: instanceOf,
  basicTypes: exports.basicTypes
};